export const NOTIFICATION_FIELD_PAYMENT = "payment";
export const NOTIFICATION_FIELD_PAYMENT_RECEIVED = "paymentReceived";

export const NOTIFICATION_FIELD_TYPES = [
  NOTIFICATION_FIELD_PAYMENT,
  NOTIFICATION_FIELD_PAYMENT_RECEIVED,
] as const;

export type NotificationFieldType = typeof NOTIFICATION_FIELD_TYPES[number];

export interface NotificationField {
  name: string;
  description: string;
  includedIn: NotificationFieldType[];
}
